export type Locale = "zh-TW" | "en";

type Dictionary = Record<string, string>;

export const dictionaries: Record<Locale, Dictionary> = {
  "zh-TW": {
    appName: "Tools",
    home: "首頁",
    toolsList: "功能列表",
    homeTitle: "日常文件工具集合",
    homeSubtitle: "把簽名、文件處理與可重複使用的檔案整理在同一個輕量工作區。",
    homeHighlights: "網站重點",
    guestMode: "未登入可單次使用",
    savedMode: "登入後可保存重用",
    onlineSignature: "線上簽名",
    onlineSignatureDesc: "建立透明手寫簽名，插入 PDF 或 DOCX，並匯出可下載檔案。",
    moreTools: "更多工具",
    moreToolsDesc: "後續工具會在這裡加入。",
    language: "語言",
    signIn: "Google 登入",
    signOut: "登出",
    guest: "單次使用",
    saved: "已登入",
    refreshWarning: "未登入資料重新整理後會消失。",
    refreshConfirm: "未登入的簽名與文件會在重新整理後消失。",
    signature: "簽名",
    documents: "文件",
    savedFiles: "已儲存",
    draw: "手寫",
    clear: "清除",
    undo: "復原",
    download: "下載",
    copy: "複製",
    save: "儲存",
    reuse: "套用",
    delete: "刪除",
    upload: "上傳",
    export: "匯出",
    pdf: "PDF",
    word: "Word",
    insertSignature: "插入簽名",
    page: "頁",
    size: "尺寸",
    noSignature: "先建立或選擇簽名。",
    noSavedFiles: "尚無儲存檔案。",
    choosePdf: "選擇 PDF",
    chooseWord: "選擇 Word",
    chooseSignature: "選擇簽名",
    signedPdf: "已簽署 PDF",
    signedWord: "已簽署 Word",
    uploadHint: "未登入僅本次使用；登入後可保存並重複使用。",
    loginToSave: "登入後可儲存",
    copied: "已複製",
    savedOk: "已儲存",
    exportedOk: "已匯出",
    loading: "讀取中",
    authError: "登入設定或流程失敗。",
    ready: "就緒",
    editor: "編輯",
    preview: "預覽",
    profile: "帳號",
    fileLimit: "上限 25MB",
    dragHint: "拖曳簽名調整位置。",
    wordFormatHint: "Word 會保留文字與插入簽名，複雜版面需再確認。",
    titlePlaceholder: "檔名",
    signatureName: "signature.png",
    pdfName: "signed-document.pdf",
    wordName: "signed-document.docx",
    pdfRenderError: "PDF 頁面無法顯示，請切換頁碼或重新上傳。",
    all: "全部",
  },
  en: {
    appName: "Tools",
    home: "Home",
    toolsList: "Tools",
    homeTitle: "Everyday Document Tools",
    homeSubtitle: "A lightweight workspace for signing, document handling, and reusable saved files.",
    homeHighlights: "Highlights",
    guestMode: "One-time guest use",
    savedMode: "Save and reuse after sign-in",
    onlineSignature: "Online Signing",
    onlineSignatureDesc: "Create transparent handwritten signatures, insert them into PDF or DOCX files, and export downloads.",
    moreTools: "More tools",
    moreToolsDesc: "Additional tools will be added here.",
    language: "Language",
    signIn: "Sign in with Google",
    signOut: "Sign out",
    guest: "One-time",
    saved: "Signed in",
    refreshWarning: "Guest work disappears after refresh.",
    refreshConfirm: "Guest signatures and documents will disappear after refresh.",
    signature: "Signature",
    documents: "Documents",
    savedFiles: "Saved",
    draw: "Draw",
    clear: "Clear",
    undo: "Undo",
    download: "Download",
    copy: "Copy",
    save: "Save",
    reuse: "Use",
    delete: "Delete",
    upload: "Upload",
    export: "Export",
    pdf: "PDF",
    word: "Word",
    insertSignature: "Insert signature",
    page: "Page",
    size: "Size",
    noSignature: "Create or select a signature first.",
    noSavedFiles: "No saved files yet.",
    choosePdf: "Choose PDF",
    chooseWord: "Choose Word",
    chooseSignature: "Choose signature",
    signedPdf: "Signed PDF",
    signedWord: "Signed Word",
    uploadHint: "Guests can use it once; signed-in users can save and reuse files.",
    loginToSave: "Sign in to save",
    copied: "Copied",
    savedOk: "Saved",
    exportedOk: "Exported",
    loading: "Loading",
    authError: "Sign-in configuration or flow failed.",
    ready: "Ready",
    editor: "Editor",
    preview: "Preview",
    profile: "Account",
    fileLimit: "25MB max",
    dragHint: "Drag the signature to position it.",
    wordFormatHint: "Word export keeps text and inserted signatures; complex layout should be reviewed.",
    titlePlaceholder: "File name",
    signatureName: "signature.png",
    pdfName: "signed-document.pdf",
    wordName: "signed-document.docx",
    pdfRenderError: "PDF page could not be displayed. Change page or upload again.",
    all: "All",
  },
};

export function detectLocale(): Locale {
  const language = navigator.language.toLowerCase();
  return language.startsWith("zh") ? "zh-TW" : "en";
}
